/**
 * The only addresses in this app that point outside the deployment.
 *
 * Gathered here because a fork, a rename or a move of the repository should be
 * one edit rather than a search. There is no download link here on purpose:
 * the extension is downloaded from the deployment itself, at /install, behind
 * sign-in — the repository and its releases need not be public, and the access
 * list decides who gets the extension (see src/releases.ts).
 */
export const REPO_URL = "https://github.com/ryan-dutton/embellisher";
export const DOCS_URL = `${REPO_URL}/tree/main/docs`;
